import React from 'react';
import PropTypes from 'prop-types';
import Component from './Component';
import Styled from './style';

const Trailers = ({ apiStatus, history, callback, trailers, insuracePortalUserRole, fleetCompanyList, handleReset, ...rest }) => {
  return (
    <>
      <Component
        {...rest}
        history={history}
        trailers={trailers}
        apiStatus={apiStatus}
        callback={callback}
        Styled={Styled}
        insuracePortalUserRole={insuracePortalUserRole}
        fleetCompanyList={fleetCompanyList}
        handleReset={handleReset}
      />
    </>
  );
};

export default Trailers;

Trailers.propTypes = {
  callback: PropTypes.func.isRequired,
  trailers: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  handleDeleteAlert: PropTypes.func.isRequired,
  apiStatus: PropTypes.object.isRequired,
};
